import React from 'react'
import classNames from 'classnames/bind'

import styles from './../skills-page.module.scss'
import Chart from "react-google-charts";

const cx = classNames.bind(styles)

export const SkillsChart = ({
    frontendSkillsGraph,
    backendSkillsGraph,
    designSkillsGraph,
    leadershipSkillsGraph,
    miscSkillsGraph,
    displayFrontEnd,
    displayBackEnd,
    displayDesign,
    displayLeadership,
    displayMisc
}) => {
    return (
        <>
            <div className={cx('row')}>
                {displayFrontEnd.length > 0 &&
                    <div className={cx(['col-12', 'col-md-6', 'animate__animated', 'animate__fadeIn'])}>
                        <Chart
                            width={'100%'}
                            height={'300px'}
                            chartType="PieChart"
                            loader={<div>Loading Front End Skills Chart</div>}
                            data={[['Skills', 'Front End'], ...frontendSkillsGraph]}
                            options={{
                                title: 'Front End Skills',
                                is3D: true,
                                pieSliceText: 'none',
                                titleTextStyle:{
                                    fontSize: "18",
                                },
                            }}
                            rootProps={{'data-frontend-skills': '1'}}
                        />
                    </div>
                }

                {displayBackEnd.length > 0 &&
                    <div className={cx(['col-12', 'col-md-6', 'animate__animated', 'animate__fadeIn'])}>
                        <Chart
                            width={'100%'}
                            height={'300px'}
                            chartType="PieChart"
                            loader={<div>Loading Back End Skills Chart</div>}
                            data={[['Skills', 'Back End'], ...backendSkillsGraph]}
                            options={{
                                title: 'Back End Skills',
                                is3D: true,
                                pieSliceText: 'none',
                                titleTextStyle:{
                                    fontSize: "18",
                                }
                            }}
                            rootProps={{'data-backend-skills': '1'}}
                        />
                    </div>
                }

                {displayDesign.length > 0 &&
                   <div className={cx(['col-12', 'col-md-6', 'animate__animated', 'animate__fadeIn'])}>
                        <Chart
                            width={'100%'}
                            height={'300px'}
                            chartType="PieChart"
                            loader={<div>Loading Design Skills Chart</div>}
                            data={[['Skills', 'Design'], ...designSkillsGraph]}
                            options={{
                                title: 'Design Skills',
                                is3D: true,
                                pieSliceText: 'none',
                                titleTextStyle:{
                                    fontSize: "18",
                                }
                            }}
                            rootProps={{'data-design-skills': '1'}}
                        />
                    </div>
                }

                {displayLeadership.length > 0 &&
                    <div className={cx(['col-12', 'col-md-6', 'animate__animated', 'animate__fadeIn'])}>
                        <Chart
                            width={'100%'}
                            height={'300px'}
                            chartType="PieChart"
                            loader={<div>Loading Leadership Skills Chart</div>}
                            data={[['Skills', 'Leadership'], ...leadershipSkillsGraph]}
                            options={{
                                title: 'Leadership Skills',
                                is3D: true,
                                pieSliceText: 'none',
                                titleTextStyle:{
                                    fontSize: "18",
                                }
                            }}
                            rootProps={{'data-leadership-skills': '1'}}
                        />
                    </div>
                }

                {displayMisc.length > 0 &&
                    <div className={cx(['col-12', 'col-md-6', 'animate__animated', 'animate__fadeIn'])}>
                        <Chart
                            width={'100%'}
                            height={'300px'}
                            chartType="PieChart"
                            loader={<div>Loading Miscellaneous Skills Chart</div>}
                            data={[['Skills', 'Miscellaneous'], ...miscSkillsGraph]}
                            options={{
                                title: 'Miscellaneous Skills',
                                is3D: true,
                                pieSliceText: 'none',
                                titleTextStyle:{
                                    fontSize: "18",
                                }
                            }}
                            rootProps={{'data-misc-skills': '1'}}
                        />
                    </div>
                }
            </div>
        </>
    )
}